<template>
    <div class="container">
        <div class="side-left">
            <img src="@/assets/logo single.png" class="logoKemnaker" alt="">

            <div class="menus">
                <div class="item-menu" :class="{ 'active-ic': activeMenu == 1 }" @click="bukaMenu(1)">
                    <i class="fad fa-messages"></i>
                    <p><small>messages</small></p>
                </div>
                <div class="item-menu" :class="{ 'active-ic': activeMenu == 2 }" @click="bukaMenu(2)">
                    <i class="fad fa-clock-rotate-left"></i>
                    <p><small>history</small></p>
                </div>
                <div style="width: 80%;height: 2px; background-color: #f2f2f2; display: block; margin: 10px auto;">
                </div>
                <div class="item-menu" :class="{ 'active-ic': activeMenu == 4 }" @click="bukaMenu(4)">
                    <i class="fad fa-chart-mixed"></i>
                    <p><small>report</small></p>
                </div>
            </div>
            <div class="settings">
                <div class="item-menu" @click="logout">
                    <i class="fas fa-right-from-bracket"></i>
                    <p><small>logout</small></p>
                </div>
            </div>
        </div>
        <div class="side-main">
            <SemuaChat v-if="semuaChat" />
            <HistoryChat v-if="historyChat" />
            <DashboardReport v-if="dashboardReport" />
        </div>
    </div>
</template>

<script>
import SemuaChat from '@/layouts/agent/InboxLayout.vue';
import HistoryChat from './agen/HistoryChat.vue';
import DashboardReport from './agen/DashboardReport.vue';
import axios from "axios"
import { backend as be } from "@/assets/config/server.js"
import { getCookie, deleteCookie } from '@/assets/config/cookie';

export default {
    name: "UserMainDash",
    components: {
        SemuaChat: SemuaChat,
        HistoryChat: HistoryChat,
        DashboardReport: DashboardReport,
    },
    props: {
        msg: String,
    },
    data() {
        return {
            itemMenuClass: "item-menu",
            activeClass: "item-menu active-ic",
            historyChat: false,
            semuaChat: true,
            dashboardReport: false,
            activeMenu: 1
        }
    },
    methods: {
        async logout() {
            const loginInfo = JSON.parse(getCookie('loginInfo'))
            const sessionToken = loginInfo.token;
            deleteCookie('loginInfo');
            this.$router.push("/")
            try {
                await axios.post(
                    `${be}/api/logout`, {},
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer ${sessionToken}`,
                        },
                    }
                );

            } catch (err) {
                console.error(err)
            }
        },
        bukaMenu(id) {
            //console.log(this.$refs.)
            this.activeMenu = id
            switch (id) {
                case 1:
                    this.semuaChat = true
                    this.historyChat = false
                    this.dashboardReport = false
                    break;

                case 2:
                    this.semuaChat = false
                    this.historyChat = true
                    this.dashboardReport = false
                    break;

                case 3:

                    break;

                case 4:
                    this.semuaChat = false
                    this.historyChat = false
                    this.dashboardReport = true
                    break;

                case 5:

                    break;

                default:
                    break;
            }
        }
    }
};
</script>

<style>
.container {
    width: 100%;
    height: 100vh;
    display: grid;
    grid-template-columns: max-content auto;
    overflow: hidden;

    .side-left {
        width: 100px;
        height: 100%;
        background-color: transparent;
        border-right: 2px solid #f2f2f2;
        display: grid;
        grid-template-rows: max-content auto max-content;

        .logoKemnaker {
            width: 45px;
            height: 45px;
            object-fit: contain;
            display: block;
            /* penting supaya margin auto bekerja */
            margin: 20px auto;
            margin-bottom: 50px;
        }


        .menus,
        .settings {
            .item-menu {
                margin: 30px 0;
                text-align: center;
                color: #b3b3b3;

                i {
                    font-size: 15pt;
                }
            }
        }
    }

    .side-main {
        width: 100%;
        height: 100vh;
        background-color: white;
        overflow: hidden;
    }

    .active-ic {
        color: #1869ff !important;
    }
}
</style>